import { Reveal } from "@/components/Reveal";
import ParallaxImage from "@/components/ParallaxImage";
import { ASSETS } from "@/lib/assets";

const CHAPTERS = [
  {
    n: "01",
    title: "Smell the hops",
    body: "Cup a handful of whole cone hops and breathe in — citrus, pine, hay and spice. This is where a beer's aroma is born.",
    img: ASSETS.hops,
    alt: "Fresh hops",
  },
  {
    n: "02",
    title: "Handle the malt",
    body: "Roll malted barley between your fingers and taste the grain. From pale to roasted, malt decides colour, body and sweetness.",
    img: ASSETS.malt,
    alt: "Malted barley",
  },
  {
    n: "03",
    title: "Taste six styles",
    body: "Six small, contrasting samples poured side by side — with tasting notes — so you can finally taste why beers differ.",
    img: ASSETS.beer,
    alt: "Beer sample",
  },
];

export default function ManifestoChapters() {
  return (
    <section className="px-6 sm:px-10 lg:px-16 py-28 lg:py-40 relative">
      <div className="mx-auto max-w-[1400px]">
        <Reveal>
          <p className="text-[var(--gold)] uppercase tracking-[0.4em] text-xs mb-6">The Idea</p>
        </Reveal>
        <Reveal delay={0.1}>
          <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl max-w-4xl leading-tight text-[var(--cream)]">
            An informal, entertaining evening about the beverage we all love.
          </h2>
        </Reveal>
        <Reveal delay={0.2}>
          <p className="font-serif-alt text-xl sm:text-2xl text-[var(--muted)] max-w-2xl mt-8 leading-relaxed">
            Matthew Lewis explains how brewing works and why different beers taste so
            different — the smelling, the handling, the tasting. No jargon. Just curiosity and a good glass.
          </p>
        </Reveal>

        <div className="grid grid-cols-1 md:grid-cols-12 gap-8 lg:gap-12 mt-24">
          {CHAPTERS.map((c, i) => (
            <Reveal
              key={c.n}
              delay={i * 0.12}
              className={
                i === 0
                  ? "md:col-span-7"
                  : i === 1
                  ? "md:col-span-5 md:mt-24"
                  : "md:col-span-8 md:col-start-4 md:-mt-8"
              }
            >
              <article className="group">
                <ParallaxImage
                  src={c.img}
                  alt={c.alt}
                  clip={i === 1 ? "rounded-t-[999px]" : "rounded-sm"}
                  className={i === 0 ? "aspect-[16/10]" : i === 1 ? "aspect-[3/4]" : "aspect-[16/9]"}
                />
                <div className="flex items-start gap-6 mt-6">
                  <span className="font-display text-6xl lg:text-7xl text-[var(--gold)] leading-none">{c.n}</span>
                  <div>
                    <h3 className="font-display text-2xl lg:text-3xl text-[var(--cream)]">{c.title}</h3>
                    <p className="font-body text-sm sm:text-base text-[var(--muted)] mt-3 max-w-md leading-relaxed">{c.body}</p>
                  </div>
                </div>
              </article>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
